import { render, staticRenderFns } from "./Testimonial.vue?vue&type=template&id=bf3a3f58&"
import script from "./Testimonial.vue?vue&type=script&lang=ts&"
export * from "./Testimonial.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports